import { toast, ToastOptions } from 'react-toastify';

// Define the base configuration with specific types
const baseToastConfig: ToastOptions = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  style: { 
    maxWidth: '100%',
    minWidth: '300px',
    width: 'fit-content'
  }
};

// Function to display success notifications
export const notifySuccess = (message: string) => {
  toast.success(message, baseToastConfig);
};

// Function to display error notifications
export const notifyError = (message: string) => {
  toast.error(message, baseToastConfig);
};

// Function to display informational notifications
export const notifyInfo = (message: string) => {
  toast.info(message, baseToastConfig);
};

// Function to display warning notifications
export const notifyWarning = (message: string) => {
  toast.warn(message, baseToastConfig);
};